import { TextLabelStyled } from './styles/TextLabelStyled'

export const TextLabel = TextLabelStyled
